import { useCallback, type ReactNode } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextLink from 'LuxKit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'

const MobileBanner = styled(MessageBanner)`
  ${mediaQueryUp.desktop} {
    display: none;
  }
`

interface Props {
  onChangeDates: () => void
  onChangeOccupancy: () => void
}

function PackageSelectionUnavailableBanner({ onChangeDates, onChangeOccupancy }: Props) {
  const intl = useIntl()
  const renderChangeDatesLink = useCallback((chunks: ReactNode) => <TextLink size="medium" onClick={onChangeDates}>{chunks}</TextLink>, [onChangeDates])
  const renderAddRoomLink = useCallback((chunks: ReactNode) => <TextLink size="medium" onClick={onChangeOccupancy}>{chunks}</TextLink>, [onChangeOccupancy])
  const message = intl.formatMessage({
    id: '9foWczSUxiZMpsbVHJt-',
    defaultMessage: 'This room is unavailable for your dates or guest count. <datesLink>Change dates</datesLink> or <roomsLink>add another room</roomsLink>.',
    description: 'Mobile banner above a room when no package is available for the selected dates or guests',
  }, {
    datesLink: renderChangeDatesLink,
    roomsLink: renderAddRoomLink,
  })

  return <MobileBanner kind="informational" density="comfortable" align="start" flush="top">{message}</MobileBanner>
}

export default PackageSelectionUnavailableBanner
